import * as React from "react";

// MUI
import { Grid, GridProps, Typography } from "@material-ui/core";
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";

// NPM
import clsx from "clsx";

// Classes
import Utility from "../../domain/classes/Utility";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface TermsAndConditionsProps extends GridProps {}

const TermsAndConditions = React.forwardRef<
	HTMLDivElement,
	TermsAndConditionsProps & WithStyles<typeof styles>
>(({ classes, className, ...gridProps }, ref) => {
	return (
		<Grid
			item
			xs={12}
			className={clsx(classes.root, className)}
			{...gridProps}
			ref={ref}
		>
			<Typography variant="body2" paragraph>
				Welcome to Practiq! We’re incredibly excited You’re here and we
				sincerely hope our products and services make Your journey
				through healthcare of the highest possible quality.
			</Typography>
			<Typography variant="body2" paragraph>
				Please read these Terms and conditions carefully as they are a
				binding agreement between You and Practiq.
			</Typography>
			<Typography variant="body2" paragraph>
				In these Terms, a reference to You or Your is a reference to a
				Third Party Health Care Provider (‘Practice’, ‘Practitioner’,
				‘Specialist’, ‘Hospital’, ‘Hospital Service’, ‘Pathology
				Provider’, ‘Pathology Service’, ‘Pharmacist’, ‘Pharmacy
				Service’, ‘Private Health Insurer’; TPHCP) or a Patient or
				Customer of a TPHCP of the Platform, or a user or subscriber to
				Practiq Sites or Services, as applicable.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq Pty Ltd ABN: 52 636 576 666 (“Practiq”, “We”, “Us”,
				“Our”) provides the software as a service (SaaS) Practice
				management platform, known as Practiq, that enables Third Party
				Health Care Providers (TPHCP’s) to manage medical records,
				prescriptions, pathology and imaging requests and results,
				appointment management, specialist referrals and letters,
				communication between TPHCP’s, their Patients and anybody
				reasonably and lawfully involved in providing health care to a
				patient, and other related functionalities via the internet or
				through a mobile or desktop application (the Platform).
			</Typography>
			<Typography variant="body2" paragraph>
				These Terms of Use ('Terms') govern Your use of Our website,
				located at http://www.Practiq.com.au/ ('the Website') (together,
				‘the Platform’). The Platform is owned and operated by Practiq
				Pty Ltd Level 7 / 1 Elizabeth St, Melbourne, VIC, 3000.
			</Typography>
			<Typography variant="body2" paragraph>
				We encourage You to read these Terms carefully. By accessing or
				using the Platform in any way, You acknowledge and confirm that
				You have read and understood these Terms and agree to abide by
				these Terms. If You do not agree to any of the Terms, You must
				not use the Platform.
			</Typography>
			<Typography variant="body2" paragraph>
				These Terms set out the basis on which We permit You to access
				and use the Platform. By accessing and using the Platform, You
				agree to be bound by these Terms of Service, which we reserve
				the right to amend from time to time without notice. We reserve
				the right to modify our Platform or Sites at any time, with or
				without notice to You. For example, We may add or remove
				functionalities or features, and We may suspend or stop a
				particular feature altogether. We also reserve the right to
				charge a fee for any of Our features at any time.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq may, at any time, amend the Third Party Health Care
				Provider Agreement, including, but not limited to, adding or
				amending any fees and charges for the Services (Variation of
				Terms). Practiq will provide You with at least 30 days’ notice
				of any Variation of Terms. A Variation of Terms takes effect on
				the date set out in the notice given by Practiq. If You do not
				wish to continue to receive the Services after the Variation of
				Terms, then You may terminate this Agreement in accordance with
				clauses relating to termination and renewal. Your continued use
				of the Services or the Platform after the effective date of the
				Variation of Terms shall be deemed to constitute acceptance by
				the You of such amendments. Any rights or liabilities which
				arise prior to the effective date of any amendment to this
				Agreement will be unaffected by the Variation of Terms.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Emergencies
			</Typography>

			<Typography variant="body2" paragraph>
				Do not use the Platform in an emergency situation. Phone 000
				immediately or attend Your nearest emergency department.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Licence to Use Platform
			</Typography>

			<Typography variant="body2" paragraph>
				Practiq grants to You a limited, revocable right to access and
				use the Platform and to print pages therefrom for personal,
				non-commercial or informational purposes only.
			</Typography>
			<Typography variant="body2" paragraph>
				Except as permitted under these Terms and applicable laws, no
				part of the Platform may be otherwise reproduced, adapted or
				transmitted in any form by any process without the specific
				written consent of Practiq.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq Services are available only to Users and Subscribers
				who:
			</Typography>
			<ol>
				<li>
					<Typography variant="body2">
						Are human (not bots, except for authorized API users)
						and with minimum ages of 16 years old for Users and 18
						years old for Subscribers. Parents of children under the
						age of 16 are solely responsible for ensuring their
						child’s profile is maintained in accordance with these
						Terms;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						Submit and then maintain truthful and accurate
						information;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						Do not impersonate any other person or entity or
						otherwise misrepresent their identity in a profile or
						elsewhere on the Platform;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						Have a valid email address, phone number and postal
						address; and
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						Do not to authorize third parties unaffiliated through
						an employer-employee or entity ownership relationship to
						use their account, profile, or messages or otherwise.
					</Typography>
				</li>
			</ol>
			<Typography variant="body2" paragraph>
				If Practiq, through any Sites, Services, or otherwise, provides
				You user authentication and access tools (e.g., username,
				password, access keys) for secure access to any Site or
				Services, You agree to keep that account access information
				protected, secure, and confidential, and not share it with
				others in any way that breaches these Terms. You agree that
				Practiq in its sole and absolute discretion may block You from
				any secure and restricted parts of any Sites or Services. You
				also agree to notify Practiq immediately of any unauthorized
				access to or use of secure and restricted parts of any Sites or
				Services that You (including but not limited to any of Your
				family members, patients and staff) know or should reasonably
				know about.
			</Typography>
			<Typography variant="body2" paragraph>
				You agree that Your rights in a subscription or use of any
				Services (including, for example, the ability to change a
				password associated with a Practiq account) may depend on
				demonstrating that You have paid for the subscription to any
				applicable Services or Sites and have no outstanding amounts
				owed to any TPHCP’s.
			</Typography>
			<Typography variant="body2" paragraph>
				You acknowledge that if You sign up for, or use, any Services
				and pay via credit card, and Practiq cannot charge Your credit
				card, Practiq may cancel Your subscription and You may lose
				access to the Services and any data associated with Your
				subscription or account.
			</Typography>
			<Typography variant="body2" paragraph>
				While some Services may be paid for via invoice pursuant to
				another Practiq Agreement, Practiq may quote additional fees for
				invoiced accounts. If Practiq has entered into an invoicing
				relationship with You, the following Terms apply unless
				superseded by another Practiq Agreement: You agree to pay all
				undisputed invoices within 30 days. You agree that Practiq may
				charge interest of 1.5% per month for past due invoices, or the
				highest rate permitted by law, and You are liable for reasonable
				attorney fees and collection costs arising from Practiq's
				efforts to collect on past due amounts. If You fail to pay an
				invoice, Practiq reserves the right to cancel Your subscription
				and access to any Sites or Services, and any data associated
				with Your subscription or the Services.
			</Typography>
			<Typography variant="body2" paragraph>
				You acknowledge that portions of the Sites and Services are
				publicly available or available to other Users and may be
				accessible by syndication programs (including data feed tools),
				search engines, metasearch tools, crawlers, metacrawlers, and
				other similar programs.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq reserves the right to monitor Your communications to the
				extent they are facilitated by any Sites or Services, and may
				disclose content and information about You, including content
				contained within Your communications, if Practiq deems it
				reasonably necessary to: (1.) conform to legal requirements or
				respond to legal process; (2.) ensure Your compliance with this
				Terms of Service, the Practiq Privacy Policy, and/or the Practiq
				Community Etiquette; or (3.) protect the rights, property,
				personal safety, or interests of Practiq, its employees,
				customers, or the public.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Copyright in Platform Content
			</Typography>

			<Typography variant="body2" paragraph>
				All content included in or made available through the Platform,
				such as text, graphics, drawings, logos, button icons, images,
				audio clips, digital downloads, data compilations, page laYout
				and software is the property of Practiq or used by Practiq under
				licence and protected by the Copyright Act 1968 (Cth) and
				international copyright laws. The compilation of all content
				included in or made available through any Practiq Service is the
				exclusive property of Practiq and protected by Australian and
				international copyright laws.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Copyright Infringement
			</Typography>

			<Typography variant="body2" paragraph>
				If You believe that Your work has been used in a way that You
				believe constitutes copyright infringement, or Your intellectual
				property rights have been otherwise violated, please notify
				Practiq at info@practiq.com.au
			</Typography>
			<Typography variant="body2" paragraph>
				In order for Practiq to assist You adequately, You must, in
				writing, identify all copyrighted work that You claim has been
				infringed (i.e. a representative list of all such works),
				identify the content on the Platform that You claim is
				infringing Your copyright with enough detail so that Practiq may
				locate it, Your statement that You have a good-faith belief that
				the disputed use is not authorised by the copyright owner, its
				agent, or the law, Your statement declaring that the
				notification is accurate, and, under penalty of perjury, that
				You are the exclusive owner of the copyright interest involved
				or that You are authorised to act on behalf of the exclusive
				owner; information reasonably sufficient to permit Practiq to
				contact You, i.e. address, telephone number, and email address;
				and Your physical or electronic signature.
			</Typography>
			<Typography variant="body2" paragraph>
				On receiving Your notice containing all of the above, Practiq
				will take whatever action, in its sole discretion, it deems
				appropriate, including removal of the disputed use from the
				Platform.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Practiq Trade Marks
			</Typography>

			<Typography variant="body2" paragraph>
				Unless otherwise indicated, the Practiq logos appearing on the
				Platform are trade marks belonging to Practiq. Any use of these
				trade mark without the prior written consent of Practiq is a
				breach of the Trade Marks Act 1995 (Cth) and relevant laws in
				other countries and is expressly prohibited.
			</Typography>
			<Typography variant="body2" paragraph>
				Third party trade marks may appear on the Platform and all
				rights therein are reserved to the registered owners of those
				trade marks.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Cookies
			</Typography>

			<Typography variant="body2" paragraph>
				Praqtiq may use cookies to collect and aggregated information on
				how You use the Platform. With this information We are better
				able to improve the Platform and the services and information it
				provides to You.
			</Typography>
			<Typography variant="body2" paragraph>
				Cookies are small pieces of text used to store information on
				web browsers. Cookies are used to store and receive identifiers
				and other information on computers, phones and other devices.
				Cookies enable Practiq to offer Services via the Platform to You
				and to understand the information that We receive about You,
				including information about Your use of the Platform, whether or
				not You are registered or logged in. The cookies that We use
				include session cookies, which are deleted when You close Your
				browser, and persistent cookies, which stay in Your browser
				until they expire or You delete them.
			</Typography>
			<Typography variant="body2" paragraph>
				Cookies also enable Us to monitor Our site registration system,
				for example, by identifying a visitor who may have previously
				registered with the Platform. We use cookies to keep You logged
				in as You navigate the check-in or Your account. Cookies can
				help us identify and impose additional security measures when
				someone may be attempting to access Your account without
				authorisation, for instance, by rapidly guessing different
				passwords.
			</Typography>
			<Typography variant="body2" paragraph>
				You can configure Your browser to accept cookies, reject
				cookies, or notify You when a cookie is being sent to You. Refer
				to the “help” menu on Your browser for further details on how to
				change Your browsers’ preferences. You may not be able to fully
				utilise the features of the Platform if You do not accept
				cookies.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Linking to the Website
			</Typography>

			<Typography variant="body2" paragraph>
				Practiq grants to You a limited, revocable, non-exclusive right
				to create a hypertext link to the home page of the Website,
				provided that Practiq is notified of, and approves, such
				hyperlink and such hyperlink does not portray Practiq or its
				products in a false, misleading or otherwise illegal or
				offensive manner. You may not make any part of the Website
				available as part of another website by use of inline imaging,
				framing technologies or any other method of incorporating parts
				of the Website into another site without the prior written
				consent of Practiq.
			</Typography>
			<Typography variant="body2" paragraph>
				You will be liable for any direct or indirect consequences of
				hyperlinking or framing and will fully indemnify Practiq in
				respect of any loss or damage suffered by Practiq in respect
				thereof.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Third Party Websites and Information
			</Typography>

			<Typography variant="body2" paragraph>
				The Platform may contain links to third party information and
				products. Such content and links are not owned, operated or
				maintained by Practiq nor are they affiliated or associated with
				Practiq in any way, unless explicitly stated by Practiq. Practiq
				is not responsible for the content of any third-party material
				appearing on the Platform or any third-party sites linked to the
				Platform. Such information, advertisements or links are purely
				for information purposes only and are not endorsements by
				Practiq as to the quality, accuracy or completeness of the
				third-party information or sites.
			</Typography>
			<Typography variant="body2" paragraph>
				If You decide to access any of the third-party services or
				websites advertised or linked, You do so entirely at Your own
				risk and, as far as lawfully possible, Practiq accepts no
				liability or responsibility for the actions or omissions of
				users of the Platform or linked sites in relation to the content
				contained therein.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Limitation of Liability
			</Typography>

			<Typography variant="body2" paragraph>
				While Practiq takes all reasonable care to include accurate and
				up-to-date information on the Platform, the information provided
				should not be relied upon as being error free or accurate and
				Practiq makes no representation or warranty as to the
				timeliness, accuracy, suitability or completeness of any
				information, content, services, materials and products provided
				on or via the Platform, nor does it accept any responsibility
				arising in any way for errors or omissions. As far as lawfully
				possible, Practiq accepts no liability or responsibility for the
				actions or omissions of any users of the Platform in relation to
				the content contained herein.
			</Typography>
			<Typography variant="body2" paragraph>
				All information provided on the Platform is general in nature
				and does not constitute medical or any other form of advice and
				is provided 'as is' without warranty of any kind, expressed or
				implied, to the fullest extent possible under law. In no event
				will Practiq be liable to any party for any direct, indirect,
				incidental or consequential damages or losses whatsoever arising
				from access to, reliance on, or use of or downloading of
				information from the Platform, (or any associated or linked
				online service), including, without limitation, damages for loss
				of profits, business interruption, loss or information or damage
				to systems due to viruses or other harmful components.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq is not responsible for the deletion, failure to store,
				misdelivery, or untimely delivery of any material accessed
				through the Platform or external sites and will not be liable
				for any damage or loss whatsoever resulting from any users
				downloading or accessing any information or material through the
				Platform.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq does not accept any responsibility or liability
				whatsoever for any interruption or discontinuance of any or all
				functionality of the Platform (including hypertext links to
				external sites if any) for any reason whatsoever.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq does not guarantee that files or programs executed
				and/or downloaded from the Platform or provided via the Platform
				are free from viruses and other unauthorised or malicious code
				or corruption that could damage or interfere with data, hardware
				or software and Practiq is not liable for any such damage or
				interference which may be suffered in connection with use of the
				online services. Practiq does not guarantee the security of any
				information sent to the Platform via the Internet and such
				information is sent at the transmitter's own risk. Practiq does
				not endorse the content of advertisements appearing on the
				Platform and has no liability in respect thereof.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Telehealth
			</Typography>

			<Typography variant="body2" paragraph>
				Practiq does not guarantee that a telehealth consultation is the
				appropriate course of treatment for Your particular health care
				concern. The Practitioner has the sole discretion to decide
				whether or not a telehealth consultation is appropriate, whether
				or not to provide any particular service, and to determine the
				health services required.
			</Typography>
			<Typography variant="body2" paragraph>
				Prior to commencing a Consultation, You agree and acknowledge
				that telehealth or ‘health care at a distance’ is not
				appropriate in cases of emergency; in some circumstances,
				including when a physical examination is required, telehealth is
				not appropriate; and You must be within Australia and be 17
				years old or over to use the Platform.
			</Typography>
			<Typography variant="body2" paragraph>
				The Platform is not intended for use in urgent or emergency
				medical situations. In such situations You should contact
				emergency services immediately. In Australia You can dial 000.
			</Typography>
			<Typography variant="body2" paragraph>
				If the Practitioner decides that the health service You require
				cannot be delivered via a telehealth consultation, the
				Practitioner will advise You of alternative health care options
				available to You.
			</Typography>
			<Typography variant="body2" paragraph>
				You acknowledge that the Platform and the Services are not
				intended for use, and must not be used, in connection with life
				support or other medical equipment or apparatus.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Booking Appointments
			</Typography>

			<Typography variant="body2" paragraph>
				Appointments are listed by appointment type and vary in cost and
				duration. By Your use of Our Services, You agree to select the
				most appropriate appointment type relative to Your specific
				concern. The naming of appointment types is general in nature
				and You are not required to share specific details about Your
				concern to anybody not directly involved in Your care. The
				services offered by TPHCP’s are stated using general
				terminology, that may have been created by the TPHCP You are
				booking with, in order to match You with the most appropriate
				TPHCP for Your concern; as well as allow the TPHCP’s to run
				their services according to their scheduled appointment times.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq makes no representation or warranty as to the accuracy,
				suitability or completeness of any information relating to
				appointment types, nor does it accept any responsibility arising
				in any way for errors or omissions.
			</Typography>
			<Typography variant="body2" paragraph>
				Not all TPHCP’s provide all services listed as being available
				by the TPHCP (e.g., only one practitioner at a clinic may be
				able to provide the service You require). You acknowledge that
				by booking an appointment type listed in the Platform that the
				appointment type may not be suitable for the concern You present
				to the TPHCP with. It is Your responsibility to ensure that the
				appointment type You have booked is relevant for Your concern
				and that You may need to phone the TPHCP to confirm the
				appropriateness of the appointment type.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Payments
			</Typography>

			<Typography variant="body2" paragraph>
				Payment options are displayed on the Platform. You agree to pay
				all fees or charges in accordance with these Terms and the fees
				and charges in effect at the time a fee or charge is due and
				payable.
			</Typography>
			<Typography variant="body2" paragraph>
				All fees and charges associated with in-person or telehealth
				appointments are pre-paid in full on the credit card provided by
				You and You agree that Practiq is authorised to immediately
				process the payment at the time Your booking is completed.
			</Typography>
			<Typography variant="body2" paragraph>
				Whether You are entitled to any refund for a telehealth
				consultation, will be determined by the Practitioner You booked
				the appointment with. Refunds, if applicable, will only be made
				using the online payment gateway to the card originally used for
				payment.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Cancellations
			</Typography>

			<Typography variant="body2" paragraph>
				You must cancel Your unwanted appointment at least 3 hours in
				advance or You will be charged 50% of the appointment cost. If
				You fail to cancel, or attend, Your appointment You will be
				billed the full consultation fee and any outstanding accounts
				will need to be settled before Your next booking.
			</Typography>
			<Typography variant="body2" paragraph>
				Receipts for payments for missed appointments will not quote
				Medicare item numbers and therefor will include GST and may not
				be eligible for claims through health insurance.
			</Typography>
			<Typography variant="body2" paragraph>
				In cases where an emergency has taken place or circumstances
				that were reasonably beyond Your control prevented You from
				attending an appointment and communicating this to the TPHCP
				before the start of Your appointment, where evidence can be
				supplied, a refund may be issued at the sole discretion of the
				TPHCP.
			</Typography>
			<Typography variant="body2" paragraph>
				Reasons such as forgetting You had an appointment or that You
				were held up at work or any other reason that could have been
				rectified by proper time management or communicating with us
				before the start of Your appointment time will not be eligible
				for a refund; and where an amount has yet to be charged, the fee
				for the consultation that was booked and missed will become due
				at the end of the allocated appointment time.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Medicare and Private Health Insurance
			</Typography>

			<Typography variant="body2" paragraph>
				By Your use of The Platform You consent to having Your Medicare
				details and eligibility for services accessed and confirmed by a
				TPHCP via the PRODA and/or ECLIPSE platforms or by phone to the
				Department of Human Services; and then communicated to any
				relevant area within the Department of Human Services for
				claiming and payments or any other reason necessary in order for
				us, or a TPHCP, to provide services to You. You accept and
				acknowledge that benefits for Medicare item numbers carry
				eligibility requirements that may not apply to You and that this
				is determined by relevant legislation, such as the Health
				Insurance Act 1973 (Cth). TPHCP’s will take reasonable steps to
				determine if You are eligible to receive benefits from Medicare
				for Medicare Service items. However, it is Your responsibility
				to communicate any information about Your history or
				circumstances that may affect Your eligibility to claim Medicare
				benefits to Your TPHCP, such as Your geographic location or
				previously claimed benefits.
			</Typography>
			<Typography variant="body2" paragraph>
				Medicare may change their eligibility requirements and benefit
				amounts from time to time and Practiq does not have control over
				these changes. We will take reasonable care in communicating any
				changes as we become aware of them. However, the information
				provided should not be relied upon as being error free or
				accurate and Practiq makes no representation or warranty as to
				the timeliness, accuracy, suitability or completeness of any
				information relating to Medicare eligibility, item numbers or
				benefit amounts, nor does it accept any responsibility arising
				in any way for errors or omissions.
			</Typography>
			<Typography variant="body2" paragraph>
				International health insurance companies may or may not accept
				Medicare item numbers as an explanation for the type of service
				that was provided to You by a TPHCP. It is Your responsibility
				to communicate with Your insurance company about claiming costs
				for health services through Your insurance policy; as well as
				the process required to claim for services with Your insurance
				policy. If additional documentation is required to be completed
				by a TPHCP, in order for You to claim health services with Your
				health insurance provider, it is Your sole responsibility to
				provide the correct documentation to Your TPHCP before Your
				appointment. You accept that by providing additional
				documentation to Your TPHCP may increase the duration of Your
				appointment, and therefore the fees for Your appointment, and
				that providing documentation to be completed after Your
				appointment has finished may result in a separate appointment
				and separate fees for the additional appointment to complete the
				documentation.
			</Typography>
			<Typography variant="body2" paragraph>
				You accept that by using The Platform You are responsible for
				payment of all fees and charges associated with services being
				provided to You; including in the event that Your insurance
				provider or Medicare determines that You are not eligible to
				claim benefits for services. In cases where an insurance
				provider or Medicare has paid for services on Your behalf and
				requires a refund for any amounts paid, You are required to
				settle the outstanding amounts in full within 7 days of You
				being notified by us that a refund to Medicare or Your insurance
				company has taken place, unless otherwise agreed.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Workers compensations
			</Typography>

			<Typography variant="body2" paragraph>
				Appointments booked in relation to workplace injuries or
				conditions are to be paid on the same day that the appointment
				takes place, unless otherwise agreed between the TPHCP and the
				workplace of the patient.
			</Typography>
			<Typography variant="body2" paragraph>
				Medicare benefits do not apply to consultations with TPHCP’s
				relating to Workers compensation claims. A receipt with fees and
				relevant details, along with any other relevant documentation,
				will be provided to the patient at the end of the appointment.
			</Typography>
			<Typography variant="body2" paragraph>
				Patients and their employers have the option to attend either
				private or bulk billing TPHCP’s for their care, but it is the
				responsibility of both the patient and their employer to
				understand the fees and fee structure before booking an
				appointment with any TPHCP. Workers compensation benefits may
				not cover the entire cost of a consultation and this may result
				in a gap fee between the amount rebated by the relevant workers
				compensation body and the amount billed for health services.
			</Typography>
			<Typography variant="body2" paragraph>
				Regulations are determined by legislation in each state and
				territory. For more information please visit:
			</Typography>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.fairwork.gov.au/leave/workers-compensation"
			>
				<Typography variant="body2" paragraph>
					https://www.fairwork.gov.au/leave/workers-compensation
				</Typography>
			</a>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.safeworkaustralia.gov.au/"
			>
				<Typography variant="body2" paragraph>
					https://www.safeworkaustralia.gov.au/
				</Typography>
			</a>
			<Typography variant="h6" color="primary" component="h6" paragraph>
				Privacy
			</Typography>

			<Typography variant="body2" paragraph>
				Practiq will not collect any personal information about You from
				Your use of the Platform, except where You have provided such
				information to Practiq In providing any personal information to
				Practiq via the Platform, You agree to Practiq handling that
				personal information as described in its Privacy Policy. You
				warrant that You have obtained the consent of any third person
				whose personal information You post to the Platform.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq may change its Privacy Policy from time to time at its
				discretion and without notice. If any such changes are made,
				Practiq will make all reasonable efforts to bring those changes
				to the attention of its Users.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Communication of Sensitive Information
			</Typography>

			<Typography variant="body2" paragraph>
				By Your use of the Platform You agree to keep Your contact
				information up to date and acknowledge that some forms of
				communication carry an inherent risk associated with that method
				of communication; and that providing Us with incorrect or out of
				date information may result in Your sensitive health information
				being sent to an unintended third party.
			</Typography>
			<Typography variant="body2" paragraph>
				Your use of the Platform constitutes agreement to release
				Practiq, and any TPHCP’s using the Platform, from any and all
				liability should Your sensitive health information be observed,
				intercepted, hacked or otherwise accessed by an unintended third
				party, to the fullest extent of the law, whereby the unintended
				third party gained access to Your information through You making
				an error, omission, improperly handling or communicating
				passwords, falling victim to a phishing attack, or any other
				reason beyond the control of Practiq or any TPHCP’s using the
				Platform.
			</Typography>
			<Typography variant="body2" paragraph>
				This may include, but is not limited to, a family member, or
				anybody other than the intended recipient, observing an SMS or
				email that has come from a TPHCP, or the Platform, that may
				contain details about an appointment with a TPHCP or Your
				sensitive health information; including, but not limited to,
				communications between Yourself and the TPHCP, referrals,
				letters, prescriptions, pathology results, imaging results,
				medical certificates, completed special consideration forms,
				completed insurance documents, completed release of medical
				record forms, certificates of capacity, fit to fly certificates,
				invoices and receipts, complaints and any other documents that
				may be generated during the course of the Platform, or a TPHCP,
				providing a service to You that may need to be sent to You, or
				to a TPHCP on Your behalf, in order to carry out services to
				You.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Collection of Information
			</Typography>

			<Typography variant="body2" paragraph>
				Practiq may collect personal information from You such as Your
				name, street, delivery and email addresses and contact telephone
				number, Contact information for a next of kin or emergency
				contact as well as information that identifies the device and
				network used to complete the check-in including browser type, IP
				address, host network and a digital signature. Practiq may
				collect other personal information from You, including Your date
				of birth and Your gender.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq may also collect health information concerning Your
				current health, including allergies, alcohol and smoking
				history, including notes of any symptoms, the details of Your
				appointment (including the Medical Practitioner or Medical
				Clinic that You wish to attend), Your prescriptions, Your
				genetic information and Your healthcare identifier (including,
				but not limited to, Your Medicare number and/or details of Your
				private health insurance fund, such as the name of Your fund and
				Your membership number).
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq may collect personal information from You in a variety
				of ways and in the following scenarios:
			</Typography>
			<ul>
				<li>
					<Typography variant="body2">
						When You register to access and to use the Platform.
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						When You complete and submit Your check-in/registration
						form for Your medical appointments.
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						When You subscribe to our newsletter or mailing list in
						relation to the Platform.
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						When You submit a complaint, SMS survey or any other
						type of survey conducted by, or on behalf of, Practiq.
					</Typography>
				</li>
			</ul>
			<Typography variant="body2" paragraph>
				Practiq collects de-identified demographic information such as
				age, gender, location, occupation, or interests, which is not
				personal information. Practiq may use such information for its
				own internal business purposes or to improve its products and
				services. Practiq may also disclose such de-identified
				information to third parties including consultants, suppliers,
				partners, customers or potential customers. If You do not wish
				for Practiq to collect or use de-identified data from You in
				this way, please contact one of Practiq’s Privacy Officers, via
				the contact information provided at the footer of this web page
				or via our ‘contact us’ form.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq collects, uses and discloses personal information where
				it is reasonably necessary for Bp to carry out its functions and
				activities. In particular, Practiq only collects personal
				information from You for any one or more of the following
				purposes:
			</Typography>
			<ul>
				<li>
					<Typography variant="body2">
						To enable Practiq to provide You with our products and
						services, including booking, telehealth and other
						products, information or services that You have
						requested using the Platform;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To facilitate the creation of an account with Practiq in
						order to enable You to access and use the Platform;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To process transactions and to administer accounts
						(including by processing of invoices, bills, statements
						of accounts and related financial matters necessary to
						enable Practiq to provide products and/or services to
						You);
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To send invoices or statements to You and to collect
						payments from You;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To address Your queries and to resolve Your complaints;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To send You information updates, marketing materials and
						newsletters (unless You have notified Practiq that You
						no longer wish to receive such marketing materials);
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						For quality assurance purposes, including to improve the
						quality of the products and services provided to You;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To undertake statistical collation and analysis in
						relation to Your use of the Platform;
					</Typography>
				</li>
				<li>
					<Typography variant="body2">
						To comply with Practiq’s contractual obligations owed to
						You and to enforce the rights that Practiq may have
						under contract or at law.
					</Typography>
				</li>
			</ul>
			<Typography variant="h6" color="primary" component="h6" paragraph>
				Force Majeure
			</Typography>

			<Typography variant="body2" paragraph>
				Neither party shall be liable for failure in its performance
				hereunder caused by any case of Force Majeure. "Force Majeure"
				shall be considered, as defined by the applicable regulation(s),
				as any irresistible or unforeseeable event, independent of the
				party suffering of the case of Force Majeure, which prevents
				this party from fulfilling its obligations.
			</Typography>
			<Typography variant="body2" paragraph>
				So that in the case: of a prepaid booking; the transaction will
				be cancelled, and the TPHCP will refund to You the prepaid
				appointment fee that has been collected. The TPHCP will have no
				further obligations with respect to the health service being
				provided to You; of a guaranteed appointment booking; the
				booking will expire, a No Show fee will not be charged to You
				and the TPCHP will have no further obligations with respect to
				the health service being provided to You.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Correction of Your personal information
			</Typography>

			<Typography variant="body2" paragraph>
				You have the right to request access to Your personal
				information, that Your personal information be deleted or
				de-identified, or that we, or a TPHCP, make corrections to
				inaccuracies relating to Your information.
			</Typography>
			<Typography variant="body2" paragraph>
				In some circumstances, Practiq, or a TPHCP, may not be able to
				comply with a request that You make in respect of Your personal
				information. For example, Practiq, or the TPHCP, may be required
				to retain certain information that You ask Us to delete for
				various reasons, such as where there is a legal requirement to
				do so. Where these reasons to refuse a request in respect of
				Your personal information exist, We will advise You of those
				reasons at the time You make Your request.
			</Typography>
			<Typography variant="body2" paragraph>
				If We do agree to Your request for the deletion or
				de-identification of Your personal information, We will delete
				or de-identify Your data but will generally assume that You
				would prefer Us to keep a note of Your phone number on a
				register of individuals who would prefer not to be contacted.
				That way, We will minimise the chances of You being contacted in
				the future where Your data is collect in unconnected
				circumstances. If You would prefer Us not to do this, You are
				free to say so.
			</Typography>
			<Typography variant="body2" paragraph>
				If You request that Your personal information is changed, and if
				Practiq does not agree to change Your personal information, we
				will enclose Your statement of the requested changes with Your
				personal information.
			</Typography>
			<Typography variant="body2" paragraph>
				If You would like to obtain access to, delete or request changes
				to Your personal information You can request this by contacting
				Our Privacy Officer.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq, or a TPHCP, can charge a reasonable fee for the time
				and cost of collating, preparing, and photocopying material for
				You if You request access to Your personal information.
			</Typography>
			<Typography variant="body2" paragraph>
				Where We have obtained Your consent to handle Your personal
				information, or consent to send You information, You may
				withdraw Your consent at any time and We will cease to carry out
				the particular activity that You previously consented to, unless
				We consider that there is an alternative reason to justify Our
				continued handling of Your personal information for this
				purpose, in which case We will inform You of this condition.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				Complaints
			</Typography>

			<Typography variant="body2" paragraph>
				If You have questions about Our Terms of Service or Privacy
				Policy, if Practiq does not agree to provide You with access to
				Your personal information; or if You have a complaint about Our
				information handling practices, You can contact Our Privacy
				Officer on the details at the footer of this web page.
			</Typography>
			<Typography variant="body2" paragraph>
				In particular, if You wish to make a complaint about how We have
				handled Your personal information, You should forward a written
				complaint to our Privacy Officer.
			</Typography>
			<Typography variant="body2" paragraph>
				We will respond in writing within 30 days of receipt of a
				complaint. If You are not satisfied with Our decision, You can
				contact Us to discuss Your concerns.
			</Typography>
			<Typography variant="body2" paragraph>
				If the complaint remains unresolved, You have the option of
				notifying the Office of the Australian Information Commissioner
				(OAIC). Contact details can be found at OAIC's website:{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://www.oaic.gov.au"
				>
					www.oaic.gov.au
				</a>
			</Typography>
			<Typography variant="body2" paragraph>
				How to contact us By letter: Level 7 / 1 Elizabeth St,
				Melbourne, VIC, 3000. By email: info@practiq.com.au
			</Typography>
			<Typography variant="body2" paragraph>
				*The inclusion of any email addresses anywhere on the Platform
				is not consent to receiving unsolicited commercial electronic
				messages or SPAM.
			</Typography>

			<Typography variant="h6" color="primary" component="h6" paragraph>
				General
			</Typography>

			<Typography variant="body2" paragraph>
				By Your use of the Platform You warrant and represent that You
				have not relied on any term, undertaking, inducement or
				representation made by, or on behalf of, Practiq which has not
				been expressly stated in this Terms of Service Agreement.
			</Typography>
			<Typography variant="body2" paragraph>
				The parties agree that the Terms and conditions of this
				Agreement and matters relating to its performance are
				confidential and shall not be disclosed to third parties unless
				the parties to this Agreement agree, except where such
				disclosure is required by law or is to the respective parties'
				advisors, who shall in turn be required to keep the disclosed
				information confidential.
			</Typography>
			<Typography variant="body2" paragraph>
				Nothing in these Terms is to be construed as creating a
				partnership between Practiq and any TPHCP nor to constitute
				either party as the agent of the other.
			</Typography>
			<Typography variant="body2" paragraph>
				Notice may be given by email or posting an electronic message to
				the Account. You agree that Practiq may give notice by posting
				an electronic message to Your Account or by sending an email to
				the address provided by You as part of the sign-up or account
				set-up process, or as later notified by You. You may send
				notices to Practiq at info@practiq.com.au. Notice by email is
				regarded as given and received at the time sent (as recorded on
				the device from which the sender sent the email) unless the
				sender receives an automated message that the email has not been
				delivered.
			</Typography>
			<Typography variant="body2" paragraph>
				Except as otherwise agreed in writing this Agreement forms the
				entire agreement between the parties and supersedes any prior
				agreement covering the same subject matter and any prior written
				or oral representations.
			</Typography>
			<Typography variant="body2" paragraph>
				This Agreement will be governed by and construed in accordance
				with the laws of the jurisdiction in which it operates (or, if
				that is more than one jurisdiction, the State of Victoria) and
				the parties submit to the non-exclusive jurisdiction of the
				courts of that jurisdiction.
			</Typography>
			<Typography variant="body2" paragraph>
				Practiq may, at any time, amend the Terms of this Agreement,
				including, but not limited to, adding or amending any fees and
				charges for the Services (Variation of Terms). Practiq will
				provide You with at least 30 days’ notice of any Variation of
				Terms. A Variation of Terms takes effect on the date set out in
				the notice given by Practiq. If the You do not wish to continue
				to receive Services after the Variation of Terms, then You may
				terminate this Agreement in by writing to us or cancelling Your
				subscription through Your account. Your continued use of the
				Services or the Platform after the effective date of the
				Variation of Terms shall be deemed to constitute acceptance by
				You of such amendments. Any rights or liabilities arises prior
				to the effective date of any amendment to this Agreement will be
				unaffected by the Variation of Terms.
			</Typography>
			<Typography variant="body2" paragraph>
				Neither party may assign or transfer (by operation of law or
				otherwise) any right or obligation under the Agreement without
				the other party's prior written consent, which may not be
				unreasonably withheld or delayed. Any assignment in violation of
				this clause shall be null and void. However, Practiq may,
				without Your consent, assign the Agreement or any rights granted
				in the Agreement, in whole or part, either: to an Affiliate; in
				connection with Practiq’s or an Affiliates' sale of a division,
				product or service; or in connection with a reorganisation,
				merger, acquisition or divestiture of Practiq or any similar
				business transaction.
			</Typography>
			<Typography variant="body2" paragraph>
				If any provision of this Agreement for any reason is declared
				invalid, such declaration will not affect the validity of any
				remaining portion of the Agreement, which remaining portion will
				remain in full force and effect as if this Agreement had been
				executed with the invalid portion thereof eliminated.
			</Typography>
		</Grid>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("TermsAndConditions"),
})(TermsAndConditions);
